import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=11b983f5&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
import style0 from "./Loader.vue?vue&type=style&index=0&id=11b983f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b983f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b983f5')) {
      api.createRecord('11b983f5', component.options)
    } else {
      api.reload('11b983f5', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=11b983f5&scoped=true&", function () {
      api.rerender('11b983f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/components/Loader.vue"
export default component.exports